export const GET_DISTRICT_DEFINITIONS = "GET_DISTRICT_DEFINITIONS"
export const GET_DISTRICT_DEFINITIONS_SUCCESS = "GET_DISTRICT_DEFINITIONS_SUCCESS"
export const GET_DISTRICT_DEFINITIONS_FAIL = "GET_DISTRICT_DEFINITIONS_FAIL"


export const ADD_DISTRICT_DEFINITION = "ADD_DISTRICT_DEFINITION"
export const ADD_DISTRICT_DEFINITION_SUCCESS = "ADD_DISTRICT_DEFINITION_SUCCESS"
export const ADD_DISTRICT_DEFINITION_FAIL = "ADD_DISTRICT_DEFINITION_FAIL"

export const UPDATE_DISTRICT_DEFINITION = "UPDATE_DISTRICT_DEFINITION"
export const UPDATE_DISTRICT_DEFINITION_SUCCESS = "UPDATE_DISTRICT_DEFINITION_SUCCESS"
export const UPDATE_DISTRICT_DEFINITION_FAIL = "UPDATE_DISTRICT_DEFINITION_FAIL"

export const DELETE_DISTRICT_DEFINITION = "DELETE_DISTRICT_DEFINITION"
export const DELETE_DISTRICT_DEFINITION_SUCCESS = "DELETE_DISTRICT_DEFINITION_SUCCESS"
export const DELETE_DISTRICT_DEFINITION_FAIL = "DELETE_DISTRICT_DEFINITION_FAIL"

export const DISTRICT_API_ERROR = "DISTRICT_API_ERROR"
